import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=01697e2e&scoped=true"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingActionButton.vue?vue&type=style&index=0&id=01697e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01697e2e",
  null
  
)

export default component.exports